import { useOrgContext } from '../contexts/org';

export function useOrg() {
  return useOrgContext();
}
